module.exports = __webpack_public_path__ + "assets/fonts/a8f301d28823d87845b3dd0fdb85d960.woff2";